import { render, staticRenderFns } from "./Boost.vue?vue&type=template&id=76368623&scoped=true"
import script from "./Boost.vue?vue&type=script&lang=js"
export * from "./Boost.vue?vue&type=script&lang=js"
import style0 from "./Boost.vue?vue&type=style&index=0&id=76368623&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76368623",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76368623')) {
      api.createRecord('76368623', component.options)
    } else {
      api.reload('76368623', component.options)
    }
    module.hot.accept("./Boost.vue?vue&type=template&id=76368623&scoped=true", function () {
      api.rerender('76368623', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Boost.vue"
export default component.exports